import axios from "axios";

// Base URL (same pattern as your other APIs)
const API_URL =
  import.meta.env.VITE_API_URL || "http://localhost:8000/api";

// ================= AUTH HEADERS =================
const getAuthHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
  };

  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("adminToken") ||
    localStorage.getItem("staffToken");

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};

// ================= PERMISSION API =================
export const permissionAPI = {
  // ================= EMPLOYEES =================

  // Get all employees
  getAllEmployees: async () => {
    try {
      const res = await axios.get(`${API_URL}/staff/all`, {
        headers: getAuthHeaders(),
      });
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },

  // Get employees by role (optional)
  getEmployeesByRole: async (role) => {
    try {
      const res = await axios.get(`${API_URL}/staff/role/${role}`, {
        headers: getAuthHeaders(),
      });
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },

  // Get single employee
  getEmployeeById: async (id) => {
    try {
      const res = await axios.get(`${API_URL}/staff/${id}`, {
        headers: getAuthHeaders(),
      });
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },

  // ================= CREATE =================
  createEmployee: async (data) => {
    try {
      const res = await axios.post(`${API_URL}/staff/create`, data, {
        headers: getAuthHeaders(),
      });
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },

  // ================= UPDATE =================
  updateEmployee: async (id, data) => {
    try {
      const res = await axios.put(`${API_URL}/staff/${id}`, data, {
        headers: getAuthHeaders(),
      });
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },

  // ================= DELETE =================
  deleteEmployee: async (id) => {
    try {
      const res = await axios.delete(`${API_URL}/staff/${id}`, {
        headers: getAuthHeaders(),
      });
      return res.data;
    } catch (err) {
      throw err.response?.data || err.message;
    }
  },

  // ================= ROLE LIST =================
  // Static roles (can also come from backend later)
  getRoles: () => {
    return ["admin", "subAdmin", "credit-manager", "staff"];
  },
};